const TUTORIAL_ACTIONS = new Set(["previous", "next", "skip"]);

export function canBeginRoundCountdown({
  activeSessionId,
  unityReadySessionId,
  tutorialCompleteSessionId,
  startedSessionId,
  countdownSessionId,
  hasUnityInstance,
  hasRun,
  hasGameKey,
}) {
  return Boolean(
    activeSessionId &&
    hasUnityInstance &&
    hasRun &&
    hasGameKey &&
    unityReadySessionId === activeSessionId &&
    tutorialCompleteSessionId === activeSessionId &&
    startedSessionId !== activeSessionId &&
    countdownSessionId !== activeSessionId
  );
}

export function parseTutorialRemoteCommand(payload) {
  const [prefix, scope, rawAction] = String(payload || "").split("|");
  const action = String(rawAction || "").toLowerCase();
  if (prefix !== "RemoteControl" || String(scope || "").toLowerCase() !== "tutorial" || !TUTORIAL_ACTIONS.has(action)) {
    return null;
  }
  return action;
}
